import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { Logo } from "../components/Logo";
import { useSettings, waLink } from "../hooks/useSettings";
import { useI18n } from "../context/I18nContext";

export const Footer = () => {
  const s = useSettings();
  const { t } = useI18n();
  return (
    <footer className="mt-24" data-testid="main-footer">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12">
        <div className="gz-card rounded-[28px] p-10 sm:p-14 grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Logo size="lg" />
            <p className="text-[#93A099] text-sm leading-relaxed mt-5 max-w-md">
              {t("footer.tagline")}
            </p>
            <div className="flex items-center gap-2 text-[#7E8C84] text-sm mt-6">
              <MapPin className="w-4 h-4 text-[#D4AF37]" />
              Monaco · Cannes · Nice · Saint-Tropez · Antibes
            </div>
          </div>

          <div>
            <h4 className="text-[12px] tracking-luxe uppercase text-[#D4AF37] mb-5">{t("footer.catalogues")}</h4>
            <ul className="space-y-3 text-sm text-[#C7D0CA]">
              <li><Link to="/voitures" className="hover:text-[#D4AF37] transition-colors">{t("footer.carsLux")}</Link></li>
              <li><Link to="/yachts" className="hover:text-[#D4AF37] transition-colors">{t("nav.yachts")}</Link></li>
              <li><Link to="/villas" className="hover:text-[#D4AF37] transition-colors">{t("nav.villas")}</Link></li>
              <li><Link to="/reserver" className="hover:text-[#D4AF37] transition-colors">{t("nav.reserve")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[12px] tracking-luxe uppercase text-[#D4AF37] mb-5">{t("footer.contact")}</h4>
            <ul className="space-y-3 text-sm text-[#C7D0CA]">
              <li>
                <a href={`tel:${s.phone}`} className="flex items-center gap-2 hover:text-[#D4AF37] transition-colors">
                  <Phone className="w-4 h-4 text-[#D4AF37]" /> {s.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${s.email}`} className="flex items-center gap-2 hover:text-[#D4AF37] transition-colors">
                  <Mail className="w-4 h-4 text-[#D4AF37]" /> {s.email}
                </a>
              </li>
              <li>
                <a href={waLink(s.whatsapp, "Bonjour GROZNY LOCATION")} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#D4AF37] transition-colors">
                  <MessageCircle className="w-4 h-4 text-[#25D366]" /> WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 py-8 text-xs text-[#7E8C84]">
          <span>© {new Date().getFullYear()} GROZNY LOCATION. {t("footer.rights")}</span>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#D4AF37] transition-colors tracking-widest uppercase">
            {t("common.adminSpace")}
          </Link>
        </div>
      </div>
    </footer>
  );
};
